import React from 'react'
import classNames from 'classnames'

function TabButton({ label, selected, onClick, modifierClasses = [] }) {
  const tabClasses = classNames(
    'tabs__tab',
    'tabs__tab--search',
    {'is-active': selected},
    modifierClasses
  )
  return (
    <button
      role='tab'
      className={tabClasses}
      aria-selected={selected}
      onClick={onClick}
    >
      {label}
    </button>
  )
}

export default TabButton
